import { captureAppMessage } from "@leagueplatform/observability";
import { CHAT_UNAVAILABLE_REASON } from "./live-chat-constants";
import type { ChatUnavailableReason } from "./live-chat-constants";

// Reports a chat that ended with an error screen for any reason other
// than out of hours, which is expected. The reason tag groups the events.
export function captureChatUnavailableMessages(
  reason?: ChatUnavailableReason
): void {
  if (import.meta.env.VITE_APP_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log(
      "[live-chat] chat unavailable, reason:",
      reason ?? "unspecified"
    );
  }
  if (reason === CHAT_UNAVAILABLE_REASON.OUT_OF_HOURS) return;
  captureAppMessage("Live chat ended with an error screen", {
    severityLevel:
      reason === CHAT_UNAVAILABLE_REASON.AUTH_ENDED ? "warning" : "error",
    tags: { chatUnavailableReason: reason ?? "unspecified" },
  }).catch(() => undefined);
}
